"use client";
import SliderNoArrows from "@/components/Carousel/SliderNoArrows";
import { TestemonialBlackImg } from "@/stories/Testemonial.stories";
import { shuffle } from "@/utils";
import { SwiperSlide } from "swiper/react";
import testimonials from "../../../public/content/testimonials.json";
import Testimonial from "../Text/Testimonial";
import Triangles from "../Triangles";
import PlayerInPage from "../Player/PlayerInPage";
import Text from "../Text/Text";
import Title from "../Text/Title";
import Newsletter from "../Cards/Newsletter";
import { NewsletterYellow } from "@/stories/Newsletter.stories";
import { sendGTMEvent } from "../Analytics";

export default function PraxisterminLayout() {
    return (
        <>
            <div className="bg-yellow flex justify-center">
                <div className="container w-full px-3 md:px-20 lg:px-24 lg:py-20 py-0 flex-col justify-center items-center gap-6 inline-flex">
                    <Title
                        title="Ein Blick ins Energiefeld gibt oft unerwartete Antworten."
                        hasPreTitle={false}
                        hasSubTitle={true}
                        hasText={true}
                        hasColorTitle={false}
                        subTitle="Worum geht's: Gespräche können Klarheit schaffen"
                        text="Erfahre mehr darüber, warum auch das beste Gespräch die Ursachen nicht lösen kann. "
                        paddings="pt-36 pb-10"
                        leadingTitle=""
                    />
                </div>
            </div>
            <div className="bg-yellow">
                <Triangles buttomToTop={false} backgroundColor="bg-turquoise" />
            </div>
            <div className="bg-turquoise">
                <div className="container w-full  py-0 px-3 ">
                    <Text
                        paddings="px-3 lg:px-70 py-10 lg:pt-30 md:px-20 "
                        title="Wo ein Einzelgespräch hilft"
                        paragraphs={[
                            "Die Grundlage des Einzelgesprächs ist eine Energiefeldanalyse. Basierend darauf beantworte ich Fragen und zeige Mechanismen auf. Daraus entstehen 100% individuelle und massgeschneiderte Lösungswege.",
                            "Ob du spezifische Fragen hast, weil du nach Lösungen suchst oder einfach etwas über dein Energiefeld erfahren willst, spielt keine Rolle. Hier bekommst du Antworten.",
                        ]}
                        leadingText="leading-7 lg:leading-8.5"
                        leading="leading-10"
                    />
                    <div className="flex justify-center text-center pb-30">
                        <PlayerInPage
                            videoId="1bd34e9559a6c53359222eab4add6dd5"
                            thumbnail="/images/thumbnails/praxisThumbnail.jpg"
                        />
                    </div>
                </div>
            </div>
            <div className="bg-turquoise">
                <Triangles buttomToTop={true} backgroundColor="bg-black" />
            </div>
            <div className="bg-black flex text-white justify-center">
                <div className="container w-full">
                    <div className="">
                        <SliderNoArrows
                            paginationColor="#FFFFFF"
                            contentEl={
                                <div className="flex justify-center items-center">
                                    {shuffle(testimonials?.testimonials)?.map(
                                        (testimonial) => {
                                            return (
                                                <SwiperSlide
                                                    key={testimonial.testimonial}
                                                >
                                                    <Testimonial
                                                        backgroundColor={
                                                            TestemonialBlackImg?.args
                                                                ?.backgroundColor
                                                        }
                                                        differentTextColor={
                                                            TestemonialBlackImg?.args
                                                                ?.differentTextColor
                                                        }
                                                        hasImage={testimonial.hasImage}
                                                        text={testimonial?.testimonial}
                                                        icon={
                                                            TestemonialBlackImg?.args
                                                                ?.icon
                                                        }
                                                        textColor={
                                                            TestemonialBlackImg?.args
                                                                ?.textColor
                                                        }
                                                        name={testimonial?.name}
                                                        hasDescription={false}
                                                        wordsInDifferentColor={[""]}
                                                        hasReadMore={true}
                                                    />
                                                </SwiperSlide>
                                            );
                                        },
                                    )}
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>
            <div className="bg-black">
                <Triangles backgroundColor="bg-orange" buttomToTop={false} />
            </div>
            <div className="bg-orange py-0 lg:py-10 w-full px-3 lg:px-20">
                <div className="container ">
                    <Text
                        paddings="px-3 lg:px-60 lg:py-30 py-10 md:px-20"
                        title="So läuft es ab"
                        hasReadMore={true}
                        paragraphSlice={1}
                        paragraphs={[
                            "Den Ablauf der persönlichen Sitzung vor Ort in der Praxis oder in Form der Telefonberatung gestaltest du mit. Wenn du zum Beispiel Fragen hast, die du gerne mit mir besprechen möchtest, kannst du  diese zu Beginn mit mir anschauen. Falls keine Fragen bestehen, frage ich in der Regel nach, ob ich das Energiefeld betrachten und die aktuelle Situation erläutern soll.",
                            "In einem zweiten Teil kann bei einer Sitzung vor Ort die Energiefeld-Instandsetzung stattfinden, falls das gewünscht und notwendig ist. Es kann aber auch sein, dass die gesamte  Gesprächszeit genutzt wird, um die aktuelle Situation zu besprechen. Das ist ganz individuell und wird vor Ort miteinander angeschaut. Zusätzlich kommt es auch darauf an, ob das Einzelgespräch eine halbe oder eine ganze Stunde dauert.",
                        ]}
                        leading="leading-10"
                        leadingText="leading-7 lg:leading-8.5"
                    />
                </div>
            </div>
            <div className="bg-orange">
                <Triangles backgroundColor="bg-blue" buttomToTop={true} />
            </div>
            <div className="bg-blue w-full px-3">
                <div className="container max-w-7xl mx-auto ">
                    <Newsletter
                        backgroundColor="bg-blue"
                        buttonText="JETZT ANFRAGEN"
                        hasCheckbox={false}
                        hasDescription={true}
                        hasInput={false}
                        title="Melde dich für ein Einzelgespräch."
                        hasSubText={false}
                        description=""
                        paddings="py-10 lg:px-72 lg:py-30"
                        buttonPaddings="lg:px-36 px-14 py-3"
                        buttonAs="a"
                        href="/de/kontakt"
                        onClickButton={() => {
                            sendGTMEvent({
                                event: "cta_click",
                                section_title: "Melde dich für ein Einzelgespräch.",
                                section_index: "5",
                                cta_text: "JETZT ANFRAGEN",
                                cta_link: `${process.env.NEXT_PUBLIC_URL}/de/kontakt`,
                            });
                        }}
                        differentText={
                            <>
                                <div className="flex  flex-col justify-center space-y-3">
                                    <div className="self-stretch text-center space-x-1 justify-center items-baseline gap-1 lg:inline-flex">
                                        <div className="text-black text-center text-xl1 font-normal  leading-8.5">
                                            Eine Stunde
                                        </div>
                                        <div className="text-black text-center text-[24px] font-bold  leading-8.5">
                                            CHF 140.00 / EURO 140.00
                                        </div>
                                    </div>
                                    <div className="self-stretch space-x-1 justify-center items-baseline  lg:inline-flex">
                                        <div className="text-black text-center text-xl1 font-normal  leading-8.5">
                                            Eine halbe Stunde
                                        </div>
                                        <div className="text-black text-center text-[24px] font-bold  leading-8.5">
                                            CHF 70.00 / EURO 70.00
                                        </div>
                                    </div>
                                    <div className="self-stretch space-x-2 justify-center items-baseline  lg:inline-flex">
                                        <div className="text-black text-center text-xl1 font-normal  leading-8.5">
                                            Ruf einfach an unter
                                        </div>
                                        <div className="text-black text-center text-[24px] font-bold  leading-8.5">
                                            +41 (0)71 220 90 64
                                        </div>
                                        <div className="text-black text-center text-xl1 font-normal  leading-8.5">
                                            oder melde dich per E-Mail
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    />
                </div>
            </div>
            <div className="bg-blue -mt-[0.1rem]">
                <Triangles buttomToTop={false} backgroundColor="bg-yellow" />
            </div>
            <div className="bg-yellow">
                <div className="container lg:px-72 md:px-30 lg:-pb-10 px-3  ">
                    <Newsletter
                        backgroundColor={NewsletterYellow.args?.backgroundColor}
                        buttonText={"Jetzt buchen"}
                        checkBoxText={NewsletterYellow.args?.checkBoxText}
                        description="Um Probleme zu lösen, braucht es Kraft. Wenn Energiefelder funktionieren, ist die Kraft da."
                        hasCheckbox={NewsletterYellow.args?.hasCheckbox}
                        hasDescription={NewsletterYellow.args?.hasDescription}
                        hasInput={NewsletterYellow.args?.hasInput}
                        hasSubText={NewsletterYellow.args?.hasSubText}
                        subText={NewsletterYellow.args?.subText}
                        paddings="py-10  lg:py-25"
                        buttonAs="a"
                        href="/de/bestellen"
                        onClickButton={() => {
                            sendGTMEvent({
                                event: "cta_click",
                                section_title:
                                    "Um Probleme zu lösen, braucht es Kraft. Wenn Energiefelder funktionieren, ist die Kraft da.",
                                section_index: "6",
                                cta_text: "Jetzt buchen",
                                cta_link: `${process.env.NEXT_PUBLIC_URL}/de/bestellen`,
                            });
                        }}
                        buttonPaddings="lg:px-36 px-14 py-3"
                        title="Funktionsstörungen im Energiefeld lösen viele Probleme aus. Wenn man keine Beratung möchte, ist die Fernbehandlung die richtige Wahl."
                    />
                </div>
            </div>
            <div className="bg-yellow">
                <Triangles buttomToTop={true} backgroundColor="bg-darkGray" />
            </div>
        </>
    );
}
